import { Dispatch, SetStateAction } from 'react';
import { TradeMode } from '@shared/types/frontend/trade';
import { Button } from '@/components/ui/button';
const TradeButtons = ({
  setTradeMode,
  showSellButton,
  setIsModalOpen
}: {
  setTradeMode: Dispatch<SetStateAction<TradeMode>>;
  showSellButton?: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
}) => {
  return <div className='flex gap-2 w-full justify-between' data-sentry-component="TradeButtons" data-sentry-source-file="TradeButtons.tsx">
      {showSellButton ? <Button type='button' className='flex-1 h-12 rounded-xl bg-[#F87171] text-genius-blue' onClick={() => {
      setTradeMode(TradeMode.SELL);
      setIsModalOpen(true);
    }}>
          Sell
        </Button> : null}
      <Button type='button' className='flex-1 h-12 rounded-xl bg-[#34D399] text-genius-blue' onClick={() => {
      setTradeMode(TradeMode.BUY);
      setIsModalOpen(true);
    }} data-sentry-element="Button" data-sentry-source-file="TradeButtons.tsx">
        Buy
      </Button>
    </div>;
};
export default TradeButtons;